export const ERROR_MESSAGES = {
  ATTEMPTS_EXHAUSTED:
    'Too many attempts. For security purposes we have lock your access to this transcript. To unlock, please contact your account manager to confirm your identity.',
  CANT_FETCH_TRANSCRIPT: 'Can not fetch the transcript',
  CANT_CREATING_TRANSCRIPT: 'Error when creating the transcript.',
  CANT_FETCH_CONFERENCE: 'Can not fetch the conference',
  CANT_UPDATE_CONFERENCE: 'Can not update the conference',
  CANT_REQUEST_HUMAN_TRANSCRIPT: 'Error while requesting human transcript',
  ACCOUNT_BLOCKED: 'Account Blocked',
  ERROR_GENERATING_PIN: 'Error when generating new PIN',
  ORGANIZATION_NAME_FIELD_API_ERROR:
    'The `Organization` instance is not valid. Details: `name` can\'t be blank (value: "").',
  ORGANIZATION_NAME_FIELD_USER_ERROR: '"Name" field is required',
};

export const SUCCESS_MESSAGES = {
  CONFERENCE_CREATED: 'Successfully created conference',
  CONFERENCE_UPDATED: 'The conference has been successfully updated.',
  HUMAN_TRANSCRIPT_REQUESTED: 'Successfully requested human transcript',
  PIN_GENERATED: 'New PIN has been generated.',
};

export default {
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
};



// WEBPACK FOOTER //
// ./config/api-messages.js